"use client";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertTriangle, Check, ChevronDown, X } from "lucide-react";
import { useState } from "react";
import { Badge } from "./ui/badge.js";
import { Button } from "./ui/button.js";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList, } from "./ui/command.js";
import { DialogSafePopover, PopoverContent, PopoverTrigger, } from "./ui/popover.js";
export function MultiModelIdSelector(_a) {
    var availableIds = _a.availableIds, value = _a.value, onChange = _a.onChange, _b = _a.placeholder, placeholder = _b === void 0 ? "Select models..." : _b, _c = _a.searchPlaceholder, searchPlaceholder = _c === void 0 ? "Search models, or paste a comma-separated list..." : _c;
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(""), search = _e[0], setSearch = _e[1];
    var toggleId = function (modelId) {
        onChange(value.includes(modelId)
            ? value.filter(function (id) { return id !== modelId; })
            : __spreadArray(__spreadArray([], value, true), [modelId], false));
    };
    var addPastedList = function (text) {
        var selectable = new Set(availableIds);
        var entries = text
            .split(/[\s,]+/)
            .map(function (entry) { return entry.trim(); })
            .filter(Boolean)
            .map(function (entry) {
            if (selectable.has(entry)) {
                return entry;
            }
            var slash = entry.indexOf("/");
            var suffix = slash >= 0 ? entry.slice(slash + 1) : entry;
            return selectable.has(suffix) ? suffix : entry;
        });
        onChange(Array.from(new Set(__spreadArray(__spreadArray([], value, true), entries, true))));
    };
    return (_jsxs("div", { className: "flex flex-col gap-2", children: [value.length > 0 ? (_jsx("div", { className: "flex flex-wrap gap-1", children: value.map(function (modelId) {
                    var unknown = !availableIds.includes(modelId);
                    return (_jsxs(Badge, { variant: unknown ? "destructive" : "secondary", className: "flex items-center gap-1 font-mono text-[11px]", title: unknown
                            ? "Not selectable here — it may be retired, unavailable, or a typo."
                            : undefined, children: [unknown ? _jsx(AlertTriangle, { className: "h-3 w-3" }) : null, modelId, _jsx("button", { type: "button", "aria-label": "Remove ".concat(modelId), className: "ml-0.5 rounded-sm opacity-70 hover:opacity-100", onClick: function () { return toggleId(modelId); }, children: _jsx(X, { className: "h-3 w-3" }) })] }, modelId));
                }) })) : null, _jsxs(DialogSafePopover, { open: open, onOpenChange: setOpen, children: [_jsx(PopoverTrigger, { asChild: true, children: _jsxs(Button, { type: "button", variant: "outline", role: "combobox", "aria-expanded": open, className: "w-full justify-between font-normal", children: [_jsx("span", { className: "truncate text-left", children: value.length === 0
                                        ? placeholder
                                        : "".concat(value.length, " model").concat(value.length === 1 ? "" : "s", " selected") }), _jsx(ChevronDown, { className: "ml-2 h-4 w-4 shrink-0 opacity-50" })] }) }), _jsx(PopoverContent, { className: "w-[420px] p-0", align: "start", children: _jsxs(Command, { children: [_jsx(CommandInput, { placeholder: searchPlaceholder, value: search, onValueChange: setSearch, onPaste: function (event) {
                                        var text = event.clipboardData.getData("text");
                                        if (!/[\s,]/.test(text.trim())) {
                                            return;
                                        }
                                        event.preventDefault();
                                        addPastedList(text);
                                        setSearch("");
                                    } }), _jsxs(CommandList, { className: "max-h-[280px]", children: [_jsx(CommandEmpty, { children: "No models found." }), availableIds.map(function (modelId) {
                                            var isSelected = value.includes(modelId);
                                            return (_jsxs(CommandItem, { value: modelId, onSelect: function () { return toggleId(modelId); }, className: "flex items-center justify-between", children: [_jsx("span", { className: "font-mono text-xs", children: modelId }), isSelected ? (_jsx(Check, { className: "h-4 w-4 text-green-600" })) : null] }, modelId));
                                        })] })] }) })] })] }));
}
//# sourceMappingURL=multi-model-id-selector.js.map